import { Spinner, Growth, cx } from '@legalzoom/ui/negroni';

export type LoadingIndicatorType = 'spinner' | 'growth' | 'spinnerOverlay';

export const LoadingIndicator = ({
  variant,
}: {
  variant: LoadingIndicatorType;
}) => {
  return (
    <div
      role="status"
      aria-label="Loading"
      className={cx(
        'z-30 flex h-full w-full items-center justify-center',
        variant === 'spinnerOverlay' ? 'bg-scrim' : 'bg-neutral-50',
      )}
    >
      {variant === 'growth' ? <Growth /> : <Spinner />}
    </div>
  );
};
